import { render, staticRenderFns } from "./card-admin-professional.vue?vue&type=template&id=6e439128&"
import script from "./card-admin-professional.vue?vue&type=script&lang=js&"
export * from "./card-admin-professional.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports